export default "__VITE_ASSET__BKmeCozd__"